export const SynthetixMarketProxy = [
	{
		inputs: [{ internalType: 'address', name: '_owner', type: 'address' }],
		payable: false,
		stateMutability: 'nonpayable',
		type: 'constructor'
	},
	{
		anonymous: false,
		inputs: [
			{ indexed: false, internalType: 'address', name: 'oldOwner', type: 'address' },
			{ indexed: false, internalType: 'address', name: 'newOwner', type: 'address' }
		],
		name: 'OwnerChanged',
		type: 'event'
	},
	{
		anonymous: false,
		inputs: [{ indexed: false, internalType: 'address', name: 'newOwner', type: 'address' }],
		name: 'OwnerNominated',
		type: 'event'
	},
	{
		anonymous: false,
		inputs: [{ indexed: false, internalType: 'bytes4', name: 'route', type: 'bytes4' }],
		name: 'RouteRemoved',
		type: 'event'
	},
	{
		anonymous: false,
		inputs: [
			{ indexed: false, internalType: 'bytes4', name: 'route', type: 'bytes4' },
			{ indexed: false, internalType: 'address', name: 'implementation', type: 'address' },
			{ indexed: false, internalType: 'bool', name: 'isView', type: 'bool' }
		],
		name: 'RouteUpdated',
		type: 'event'
	},
	{
		anonymous: false,
		inputs: [{ indexed: false, internalType: 'address', name: 'targetedRoute', type: 'address' }],
		name: 'TargetedRouteAdded',
		type: 'event'
	},
	{
		anonymous: false,
		inputs: [{ indexed: false, internalType: 'address', name: 'targetedRoute', type: 'address' }],
		name: 'TargetedRouteRemoved',
		type: 'event'
	},
	{ payable: true, stateMutability: 'payable', type: 'fallback' },
	{
		constant: false,
		inputs: [
			{ internalType: 'bytes', name: 'callData', type: 'bytes' },
			{ internalType: 'uint256', name: 'numTopics', type: 'uint256' },
			{ internalType: 'bytes32', name: 'topic1', type: 'bytes32' },
			{ internalType: 'bytes32', name: 'topic2', type: 'bytes32' },
			{ internalType: 'bytes32', name: 'topic3', type: 'bytes32' },
			{ internalType: 'bytes32', name: 'topic4', type: 'bytes32' }
		],
		name: '_emit',
		outputs: [],
		payable: false,
		stateMutability: 'nonpayable',
		type: 'function'
	},
	{
		constant: false,
		inputs: [],
		name: 'acceptOwnership',
		outputs: [],
		payable: false,
		stateMutability: 'nonpayable',
		type: 'function'
	},
	{
		constant: false,
		inputs: [
			{ internalType: 'bytes4', name: 'selector', type: 'bytes4' },
			{ internalType: 'address', name: 'implementation', type: 'address' },
			{ internalType: 'bool', name: 'isView', type: 'bool' }
		],
		name: 'addRoute',
		outputs: [],
		payable: false,
		stateMutability: 'nonpayable',
		type: 'function'
	},
	{
		constant: true,
		inputs: [],
		name: 'getAllTargets',
		outputs: [{ internalType: 'address[]', name: '', type: 'address[]' }],
		payable: false,
		stateMutability: 'view',
		type: 'function'
	},
	{
		constant: true,
		inputs: [{ internalType: 'bytes4', name: 'selector', type: 'bytes4' }],
		name: 'getRoute',
		outputs: [
			{
				components: [
					{ internalType: 'bytes4', name: 'selector', type: 'bytes4' },
					{ internalType: 'address', name: 'implementation', type: 'address' },
					{ internalType: 'bool', name: 'isView', type: 'bool' }
				],
				internalType: 'struct ProxyPerpsV2.Route',
				name: '',
				type: 'tuple'
			}
		],
		payable: false,
		stateMutability: 'view',
		type: 'function'
	},
	{
		constant: true,
		inputs: [],
		name: 'getRoutesLength',
		outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
		payable: false,
		stateMutability: 'view',
		type: 'function'
	},
	{
		constant: true,
		inputs: [
			{ internalType: 'uint256', name: 'index', type: 'uint256' },
			{ internalType: 'uint256', name: 'pageSize', type: 'uint256' }
		],
		name: 'getRoutesPage',
		outputs: [
			{
				components: [
					{ internalType: 'bytes4', name: 'selector', type: 'bytes4' },
					{ internalType: 'address', name: 'implementation', type: 'address' },
					{ internalType: 'bool', name: 'isView', type: 'bool' }
				],
				internalType: 'struct ProxyPerpsV2.Route[]',
				name: '',
				type: 'tuple[]'
			}
		],
		payable: false,
		stateMutability: 'view',
		type: 'function'
	},
	{
		constant: false,
		inputs: [{ internalType: 'address', name: '_owner', type: 'address' }],
		name: 'nominateNewOwner',
		outputs: [],
		payable: false,
		stateMutability: 'nonpayable',
		type: 'function'
	},
	{
		constant: true,
		inputs: [],
		name: 'nominatedOwner',
		outputs: [{ internalType: 'address', name: '', type: 'address' }],
		payable: false,
		stateMutability: 'view',
		type: 'function'
	},
	{
		constant: true,
		inputs: [],
		name: 'owner',
		outputs: [{ internalType: 'address', name: '', type: 'address' }],
		payable: false,
		stateMutability: 'view',
		type: 'function'
	},
	{
		constant: false,
		inputs: [{ internalType: 'bytes4', name: 'selector', type: 'bytes4' }],
		name: 'removeRoute',
		outputs: [],
		payable: false,
		stateMutability: 'nonpayable',
		type: 'function'
	}
];
